import React from 'react'

import classes from './ActionGroup.scss'

import Button from '../../UI/Button/Button'
import { Grid, IconButton, Menu, MenuItem, ListItemIcon } from '@material-ui/core'
import {
  GetAppRounded,
  FilterList,
  PublishRounded,
  CloudDownload,
  MoreVert
} from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'

import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const ITEM_HEIGHT = 48

const ActionGroup = ({
  show,
  exportButtonClicked,
  importButtonClicked,
  downloadButtonClicked,
  filterButtonClicked,
  importDisabled,
  exportDisabled,
  translate
}) => {
  const theme = useTheme()
  const MobileVertical = useMediaQuery(theme.breakpoints.down('xs'))
  const MobileHorizon = useMediaQuery(theme.breakpoints.only('sm'))
  const Other = useMediaQuery(theme.breakpoints.up('md'))

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = key => {
    switch (key) {
      case 'export':
        exportButtonClicked()
        break
      case 'import':
        importButtonClicked()
        break
      case 'download':
        downloadButtonClicked()
        break
      case 'filter':
        filterButtonClicked()
        break
      default:
        break
    }
    setAnchorEl(null)
  }

  let shouldShow = ['export', 'import', 'download', 'filter']
  if (show) {
    shouldShow = show
  }

  return (
    <>
      {MobileVertical ? (
        <Grid
          container
          direction={'row'}
          justify={'flex-end'}
          alignItems={'flex-start'}
          style={{ marginTop: '-8px' }}>
          <IconButton
            aria-label='more'
            aria-controls='long-menu'
            aria-haspopup='true'
            onClick={handleClick}>
            <MoreVert />
          </IconButton>
          <Menu
            id='long-menu'
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: '20ch'
              }
            }}>
            {shouldShow.includes('export') ? <MenuItem key={'export'} onClick={() => handleClose('export')}>
              <ListItemIcon>
                <GetAppRounded fontSize='small' />
              </ListItemIcon>
              {translate('export')}
            </MenuItem> : null}
            {shouldShow.includes('import') ? <MenuItem key={'import'} onClick={() => handleClose('import')}>
              <ListItemIcon>
                <PublishRounded fontSize='small' />
              </ListItemIcon>
              {translate('import')}
            </MenuItem> : null}
            {shouldShow.includes('download') ? <MenuItem key={'download'} onClick={() => handleClose('download')}>
              <ListItemIcon>
                <CloudDownload fontSize='small' />
              </ListItemIcon>
              {translate('download')}
            </MenuItem> : null}
            {shouldShow.includes('filter') ? <MenuItem key={'filter'} onClick={() => handleClose('filter')}>
              <ListItemIcon>
                <FilterList fontSize='small' />
              </ListItemIcon>
              {translate('filter')}
            </MenuItem> : null}
          </Menu>
        </Grid>
      ) : null}
      {MobileHorizon ? (
        <div className={classes.ActionGroup}>
          {shouldShow.includes('export') ? (
            <span className={classes.ButtonWrapper}>
              <Button
                style={{
                  maxWidth: '50px',
                  maxHeight: '36px',
                  minWidth: '35px',
                  minHeight: '30px'
                }}
                disabled={exportDisabled}
                clicked={exportButtonClicked}
                startIcon={<GetAppRounded style={{ marginLeft: '10px' }} />}
                size={'large'}
                variant={'outlined'}></Button>
            </span>
          ) : null}
          {shouldShow.includes('import') ? (
            <span className={classes.ButtonWrapper}>
              <Button
                style={{
                  maxWidth: '50px',
                  maxHeight: '36px',
                  minWidth: '35px',
                  minHeight: '30px'
                }}
                clicked={importButtonClicked}
                startIcon={<PublishRounded style={{ marginLeft: '10px' }} />}
                disabled={importDisabled}
                size={'large'}
                variant={'outlined'}></Button>
            </span>
          ) : null}
          {shouldShow.includes('download') ? (
            <span className={classes.ButtonWrapper}>
              <Button
                style={{
                  maxWidth: '50px',
                  maxHeight: '36px',
                  minWidth: '35px',
                  minHeight: '30px'
                }}
                clicked={downloadButtonClicked}
                startIcon={<CloudDownload style={{ marginLeft: '10px' }} />}
                size={'large'}
                variant={'outlined'}>
                {/* {translate('download')} */}
              </Button>
            </span>
          ) : null}
          {shouldShow.includes('filter') ? (
            <span className={classes.ButtonWrapper}>
              <Button
                style={{
                  maxWidth: '50px',
                  maxHeight: '36px',
                  minWidth: '35px',
                  minHeight: '30px'
                }}
                clicked={filterButtonClicked}
                size={'large'}
                variant={'outlined'}>
                <FilterList />
              </Button>
            </span>
          ) : null}
        </div>
      ) : null}
      {Other ? (
        <div className={classes.ActionGroup}>
          {shouldShow.includes('export') ? (
            <span className={classes.ButtonWrapper}>
              <Button
                disabled={exportDisabled}
                clicked={exportButtonClicked}
                startIcon={<GetAppRounded />}
                size={'small'}
                variant={'outlined'}>
                {translate('export')}
              </Button>
            </span>
          ) : null}
          {shouldShow.includes('import') ? (
            <span className={classes.ButtonWrapper}>
              <Button
                clicked={importButtonClicked}
                startIcon={<PublishRounded />}
                disabled={importDisabled}
                size={'small'}
                variant={'outlined'}>
                {translate('import')}
              </Button>
            </span>
          ) : null}
          {shouldShow.includes('download') ? (
            <span className={classes.ButtonWrapper}>
              <Button
                clicked={downloadButtonClicked}
                startIcon={<CloudDownload />}
                size={'small'}
                variant={'outlined'}>
                {translate('download')}
              </Button>
            </span>
          ) : null}
          {shouldShow.includes('filter') ? (
            <span className={classes.ButtonWrapper}>
              <Button
                clicked={filterButtonClicked}
                startIcon={<FilterList />}
                size={'small'}
                variant={'outlined'}>
                {translate('filter')}
              </Button>
            </span>
          ) : null}
        </div>
      ) : null}
    </>
  )
}

export default withTranslate(ActionGroup)
